/**
 * Fetch AI generation history for roteiros from Supabase.
 *
 * RLS ensures users only see their own rows.
 */

import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "@/lib/supabase";
import type { AiJobRow } from "../types";

export async function getAiJobs(client: SupabaseClient = supabase): Promise<AiJobRow[]> {
  const baseSelect = `
    id,
    task,
    status,
    model_id,
    created_at,
    finished_at,
    cost_usd,
    ai_job_results (
      analysis_json
    )
  `;

  const buildQuery = (selectClause: string) =>
    client
      .from("ai_jobs")
      .select(selectClause)
      .eq("task", "roteiros")
      .order("created_at", { ascending: false })
      .limit(50);

  let { data, error } = await buildQuery(
    `
      ${baseSelect},
      request_metadata
    `,
  );

  if (error?.message?.includes("request_metadata")) {
    const fallback = await buildQuery(baseSelect);
    data = fallback.data?.map((row) => ({
      ...row,
      request_metadata: null,
    }));
    error = fallback.error;
  }

  if (error) throw new Error(error.message);
  return (data ?? []) as AiJobRow[];
}
